import React from 'react'
import './Image.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {graphql} from 'gatsby'

export default function Image({image}) {
	return(
		<div className="Image">
			<GatsbyImage image={getImage(image.localFile.childImageSharp)} alt={image.altText} />
		</div>
	)
}

export const query = graphql`
	fragment Image on WpPage_Layout_block_Layout_Image {
		fieldGroupName
		image {
			altText
			localFile {
				childImageSharp {
					gatsbyImageData(
						width: 2000,
						height: 1000,
						placeholder: DOMINANT_COLOR,
						transformOptions: {cropFocus: CENTER}
					)
				}
			}
		}
	}
`